const mobileKitTrigger = document.querySelector(".mobile-kit__trigger");
const kitDrawer = document.querySelector("kit-drawer");
const kitDrawerItems = document.querySelector(
  "kit-drawer-items #CartDrawer-CartItems"
);
const kitDrawerFooter = document.querySelector("kit-drawer .drawer__footer");
const pageOverlay = document.querySelector(".page-overlay");
const kitCloseTriggers = document.querySelectorAll(
  ".mobile-kit__close-trigger"
);
const saveItemsButtons = document.querySelectorAll(".not-a-customer .save-btn");
const saveItemsModal = document.querySelector(".save-items__modal");
const modalCloseButtons = document.querySelectorAll(".modal-close");
const addNewAddressButton = document.querySelector(".add-new-address__button");
const addressEditButtons = document.querySelectorAll(".address-edit-button");
const addAddressBlock = document.querySelector(".add-address-block");
const editAddressBlocks = document.querySelectorAll(".edit-address-block");
const accountTabs = document.querySelectorAll(".account-tab");
const accountTabsContent = document.querySelectorAll(".account-tab__content");
const accountAddressTabsContent = document.querySelectorAll(
  ".account-tab__content-address-blocks"
);
const accountBreadcrumbs = document.querySelectorAll(".account-breadcrumb");
const kitTabs = document.querySelectorAll(".kit-tab");
const kitItems = document.querySelectorAll(".kit-items");
const kitsWrapper = document.querySelector(".build-kit-items__wrapper");
const kitsModalTriggers = document.querySelectorAll(".kits-dialog__trigger");
const kitItemsClose = document.querySelector(".build-kit-items__close");
const menuDrawerCloseButton = document.querySelector(
  ".menu-drawer-close-button"
);
const commentButton = document.querySelector(".comment-button");
const cardProducts = document.querySelectorAll(".simple-product-card-wrapper");
const checkouButton = document.getElementById('checkout');

mobileKitTrigger &&
  mobileKitTrigger.addEventListener("click", () => {
    kitDrawer.classList.add("kit-drawer__visible");
    pageOverlay.classList.add("page-overlay__visible");
  });

const calculateKitDrawerItemsHeight = () => {
  kitDrawerItems.style.height = `calc(100vh - ${
    kitDrawerFooter.offsetHeight + 120
  }px)`;
};

if (kitDrawerItems) {
  window.addEventListener("DOMContentLoaded", calculateKitDrawerItemsHeight);
  window.addEventListener("resize", calculateKitDrawerItemsHeight);
}

const kitDrawerCloseHandler = () => {
  kitDrawer.classList.remove("kit-drawer__visible");
  pageOverlay.classList.remove("page-overlay__visible");
};

kitCloseTriggers.forEach((kitCloseTrigger) => {
  kitCloseTrigger.addEventListener("click", kitDrawerCloseHandler);
});

pageOverlay && pageOverlay.addEventListener("click", kitDrawerCloseHandler);

function tabsHandler(tabs, tabsContent) {
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabsContent.forEach((tabContent) => {
        tabs.forEach((tab) => {
          tab.classList.remove("tab-active");
        });
        tabContent.classList.remove("tab-content__active");
      });
      tab.classList.add("tab-active");
      tabsContent[index].classList.add("tab-content__active");
    });
  });
}

saveItemsButtons.forEach((saveItemsButton) => {
  saveItemsButton.addEventListener("click", () => {
    saveItemsModal.showModal();
  });
});

modalCloseButtons.forEach((modalCloseButton) => {
  modalCloseButton.addEventListener("click", () => {
    modalCloseButton.closest("dialog").close();
    // saveItemsModal.close();
  });
});

addNewAddressButton &&
  addNewAddressButton.addEventListener("click", () => {
    accountAddressTabsContent.forEach((addressBlock) => {
      addressBlock.classList.remove(
        "account-tab__content-address-blocks--visible"
      );
    });

    addAddressBlock.classList.add(
      "account-tab__content-address-blocks--visible"
    );
  });

addressEditButtons.forEach((addressEditButton, index) => {
  addressEditButton.addEventListener("click", () => {
    accountAddressTabsContent.forEach((addressBlock) => {
      addressBlock.classList.remove(
        "account-tab__content-address-blocks--visible"
      );
    });
    editAddressBlocks[index].classList.add(
      "account-tab__content-address-blocks--visible"
    );
  });
});

tabsHandler(accountTabs, accountTabsContent);

function myInfoTabActiveHandler(myInfoButton) {
  myInfoButton.addEventListener("click", () => {
    accountAddressTabsContent.forEach((addressBlock) => {
      addressBlock.classList.remove(
        "account-tab__content-address-blocks--visible"
      );
    });
    accountAddressTabsContent[0].classList.add(
      "account-tab__content-address-blocks--visible"
    );
  });
}

accountTabs.length > 0 && myInfoTabActiveHandler(accountTabs[1]);

function deactivateAllTabs() {
  accountTabs.forEach((accountTab) => {
    accountTab.classList.remove("tab-active");
  });
  accountTabsContent.forEach((accountTabContent) => {
    accountTabContent.classList.remove("tab-content__active");
  });
}

if (document.documentElement.offsetWidth < 990) {
  deactivateAllTabs();
}

accountBreadcrumbs.forEach((accountBreadcrumb) => {
  myInfoTabActiveHandler(
    accountBreadcrumb.querySelectorAll(".breadcrumb-button")[1]
  );
  accountBreadcrumb
    .querySelectorAll(".breadcrumb-button")[0]
    .addEventListener("click", deactivateAllTabs);
});

tabsHandler(kitTabs, kitItems);

kitsModalTriggers.forEach((kitsModalTrigger) => {
  kitsModalTrigger.addEventListener("click", () => {
    kitsWrapper && kitsWrapper.classList.toggle("hidden");
    if (kitsWrapper && kitsWrapper.classList.contains("hidden")) {
      kitsModalTrigger.textContent = "View Kits";
    } else {
      kitsModalTrigger.textContent = "Hide Kits";
    }
  });

  kitItemsClose &&
    kitItemsClose.addEventListener("click", () => {
      kitsWrapper.classList.add("hidden");
      kitsModalTrigger.textContent = "View Kits";
    });
});

menuDrawerCloseButton &&
  menuDrawerCloseButton.addEventListener("click", () => {
    document.querySelector("summary.header__icon--menu").click();
  });

commentButton &&
  commentButton.addEventListener("click", () => {
    commentButton.nextElementSibling.showModal();
  });

document.addEventListener("DOMContentLoaded", () => {
  if (document.documentElement.offsetWidth < 990 && kitsWrapper) {
    kitsWrapper.classList.add("hidden");
  }
});

// cardProducts.forEach((cardProduct) => {
//   const mainImage = cardProduct
//     .querySelector(".card-product__main-image")
//     .getAttribute("src");
//   // const swatchInputs = cardProduct.querySelectorAll(".swatch-input__input");

//   // swatchInputs.forEach((swatchInput) => {
//   //   swatchInput.checked = false;
//   // });

//   cardProduct.addEventListener("click", (event) => {
//     if (
//       (event.target.classList.contains("swatch-input__label") ||
//         event.target.closest(".swatch-input__label")) &&
//       event.target.closest(".swatch-input__label").getAttribute("data-image")
//     ) {
//       event.target
//         .closest(".product-card-wrapper")
//         .querySelector(".card-product__main-image")
//         .setAttribute("src", event.target.dataset.image);
//     } 
//   });
// });

setInterval(function () {
  preCollSaveBtn();
}, 1000);

preCollSaveBtn();

// function preCollSaveBtn() {
//   const cardProductsBtn = document.querySelectorAll(".card-product__addtocart");
//   cardProductsBtn.forEach((cardProductbtn) => {
//     if (cardProductbtn.classList.contains("checkk")) {
//     } else {
//       cardProductbtn.classList.add("checkk");
//       cardProductbtn.addEventListener("click", (event) => {
//         let variantId = event.target.getAttribute("data-variant-id");
//         console.log(variantId);
//         let items = [];
//         if (variantId) {
//           items.push({
//             id: variantId,
//             quantity: 1,
//           });
//         }
//         if (items.length > 0) {
//           fetch("/cart/add.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//             },
//             body: JSON.stringify({ items: items }),
//           })
//             .then((response) => response.json())
//             .then((data) => {
//               getCarts();
//               const notification = document.getElementById("cart-notification");
//               notification.classList.add("animate", "active");
//               hideNotification();
//             })
//             .catch((error) => {
//               console.error("Error adding items to cart:", error);
//             });
//         }
//       });
//     }
//   });
// }


function preCollSaveBtn() {
  const cardProductsBtn = document.querySelectorAll(".card-product__addtocart");

  cardProductsBtn.forEach((cardProductbtn) => {
    if (!cardProductbtn.classList.contains("checkk")) {
      cardProductbtn.classList.add("checkk");

      cardProductbtn.addEventListener("click", (event) => {
        let variantId = cardProductbtn.getAttribute("data-variant-id");

        let items = [];
        if (variantId) {
          items.push({
            id: variantId,
            quantity: 1,
          });
        }

        if (items.length > 0) {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ items: items }),
          })
            .then((response) => response.json())
            .then(() => {
              return fetch("/cart.js");
            })
            .then((res) => res.json())
            .then((cart) => {
              const countEls = document.querySelectorAll("[data-cart-item-count]");
              countEls.forEach((el) => {
                el.innerHTML = cart.item_count;
              });
              const notification = document.getElementById("cart-notification");
              notification.classList.add("animate", "active");
              hideNotification();

              // optional if still needed
              getCarts();
            })
            .catch((error) => {
              console.error("Error adding items to cart:", error);
            });
        }
      });
    }
  });
}



/***/
let productData = [];

function CreateSaveBtn(productData) {
  var gridItems = document.querySelectorAll(".save-btn");
  gridItems.forEach((item) => {
    const prod_id = item.getAttribute("data-variantid");
    let foundObject = productData.find(
      (element) => element.product_id === prod_id
    );
    if (foundObject != undefined) {
      item.classList.add("saved");
    }
  });
}
//
function removeSavedNtoification(target, Name) {
  const saveNotification = target.querySelector(".save-indicator__text");
  if (saveNotification) {
    saveNotification.style.display = "inline-flex";
  }
  const saveIconBtn = target.querySelector(".icon-save");
  if (saveIconBtn) {
    saveIconBtn.style.display = "none";
  }
  setTimeout(function () {
    if (saveNotification) {
      saveNotification.style.display = "none";
    }
    if (saveIconBtn) {
      saveIconBtn.style.display = "block";
    }
  }, 2000);
}

function showHtmlKits(responseData) {
  console.log(responseData);
  responseData = responseData.filter((kit) => kit !== null);
  const countContact = document.querySelector(".contact__kit-count");
  if (countContact) {
    countContact.innerHTML = `( ${responseData.length} Items)`;
  }
  let htmlCustom = "";
  let contactHtml = "";
  for (let kit of responseData) {
    if (kit.mode === "pre-made-kits") {
      const dataString = JSON.parse(kit.data);
      const productArray = Object.entries(dataString);
      productData.push({ id: kit.id, product_id: productArray[0][0] });
    } else {
      htmlCustom += `<div class="kit-item" data-kitid="${kit.id}">
        <div class="kit-info">
          <figure class="kit-image">
            <img src="https://cdn.shopify.com/s/files/1/0864/0784/0055/files/kit-image.avif?v=1721912985">
          </figure>
          <h3 class="kit-name">${kit.name}</h3>
        </div>
        <div class="kit-price__wrapper right">
          <div class="kit-actions">
            <button type="button" class="link previus-kitId" data-kitId="${kit.id}"><svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-edit">
<path d="M14.9998 15.75H2.99976M11.9998 3C11.8123 4.3125 12.9373 5.4375 14.2498 5.25M5.24976 12L5.56981 10.7198C5.72984 10.0797 5.80985 9.7596 5.93853 9.4612C6.05276 9.19627 6.19533 8.94448 6.36373 8.71022C6.55341 8.44635 6.7867 8.21307 7.25327 7.74651L12.3749 2.62499C12.9962 2.00368 14.0035 2.00369 14.6248 2.62502V2.62502C15.2461 3.24633 15.2461 4.25366 14.6248 4.87495L9.50324 9.99651C9.03668 10.4631 8.8034 10.6964 8.53954 10.886C8.30528 11.0544 8.05349 11.197 7.78857 11.3112C7.49016 11.4399 7.1701 11.5199 6.52999 11.6799L5.24976 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <span>Edit Kit</span></button>
          </div>
        </div>
      </div>`;
      let dataCount = JSON.parse(kit.data);
      dataCount = JSON.parse(dataCount);
      const length = Object.entries(dataCount).length;
      contactHtml += `<div class="kit-item">
            <div class="kit-info">
              <figure class="kit-image">
                <img src="https://cdn.shopify.com/s/files/1/0864/0784/0055/files/kit-image.avif?v=1721912985">
              </figure>
              <div class="kit-info__inner">
                <h3 class="kit-name">${kit.name}</h3>
                <span class="kit-items-count">${length} items</span>
              </div>
            </div>
          </div>`;
    }
  }
  const modalwrapperKitItem = document.querySelector(
    ".build-kit-items__wrapper"
  );
  if (htmlCustom === "") {
    if (modalwrapperKitItem) {
      modalwrapperKitItem.classList.add("hidden");
    }
  } else {
    if (modalwrapperKitItem) {
      modalwrapperKitItem.classList.remove("hidden");
    }
  }
  const modalKitItem = document.querySelector(".build-kit-items");
  if (modalKitItem) {
    modalKitItem.innerHTML = htmlCustom;
  }
  const contatcKitItems = document.querySelector(
    ".contact__kit-count-wrapper .kit-items"
  );

  if (contatcKitItems) {
    contatcKitItems.innerHTML = contactHtml;
  }
  CreateSaveBtn(productData);
}

document.addEventListener("click", function (event) {
  const apiUrl = "https://website-0bc9a756.frt.izk.mybluehost.me/api/";

  if (
    (event.target.classList.contains("saved") &&
      event.target.classList.contains("save-btn")) ||
    (event.target.closest(".saved") && event.target.closest(".save-btn"))
  ) {
    let target = event.target.classList.contains("save-btn")
      ? event.target
      : event.target.closest(".save-btn");

    const productId = target.getAttribute("data-variantid");
    var deleteData = productData.find((x) => x.product_id == productId);
    if (deleteData != undefined) {
      const url = new URL(apiUrl+'deleteAction');
      url.searchParams.append("action", "deleteAction");
      url.searchParams.append("cust_id", __st.cid);
      url.searchParams.append("id", deleteData.id);
      fetch(url, {
        method: "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json(); // Assuming the response is JSON
        })
        .then((data) => {
          // removeSavedNtoification(target, 'Removed');
          let allSaveKits = localStorage.getItem("allSaveKits");
          if (allSaveKits) {
            allSaveKits = JSON.parse(allSaveKits);
            allSaveKits = allSaveKits.filter((kit) => kit !== null);
            allSaveKits = allSaveKits.filter((x) => x.id != deleteData.id);
            localStorage.setItem("allSaveKits", JSON.stringify(allSaveKits));
          }
          productData = productData.filter((data) => data.id != deleteData.id);
          productData.push(productData);
          console.log(target);
          target.classList.remove("saved");
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    }
  } else if (
    event.target.classList.contains("save-btn") ||
    event.target.closest(".save-btn")
  ) {
    event.preventDefault();
    if (__st.cid) {
      let target = event.target.classList.contains("save-btn")
        ? event.target
        : event.target.closest(".save-btn");

      const productId = target.getAttribute("data-variantid");
      const productUrl = target.getAttribute("data-url");
      console.log(productId);
      const headingText = target.getAttribute("data-title");
      let productDatass = {
        [productId]: {
          producthandle: productUrl,
          quantity: 1,
          basequantity: 1,
        },
      };
      const postData = {
        action: "postAction",
        data: JSON.stringify(productDatass),
        cust_id: __st.cid,
        kitName: headingText,
        kitQuantity: "1",
        mode: "pre-made-kits",
      };

      fetch(apiUrl+"postAction", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(postData).toString(),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((response) => {
          if (response.status == "success") {
            target.classList.add("saved");
            removeSavedNtoification(target, "Saved");
            let allSaveKits = localStorage.getItem("allSaveKits");
            if (allSaveKits) {
              allSaveKits = JSON.parse(allSaveKits);
              allSaveKits.push(response.data);
              localStorage.setItem("allSaveKits", JSON.stringify(allSaveKits));
            }
            const dataString = JSON.parse(response.data.data);
            const productArray = Object.entries(dataString);
            productData.push({
              id: response.data.id,
              product_id: productArray[0][0],
            });
            console.log(productData);
          }
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    } else {
      saveItemsModal.showModal();
      console.log("Please Login First");
    }
  }
});

if (__st.pageurl.includes("account")) {
} else if (__st.p === "home") {
  const apiUrl = "https://website-0bc9a756.frt.izk.mybluehost.me/api/getAction";
  if (__st.cid) {
    const url = new URL(apiUrl);
    url.searchParams.append("id", __st.cid);

    fetch(url, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Assuming the response is JSON
      })
      .then((response) => {
        console.log("Response custom:", response);
        if (response.status == "success") {
          response.data = response.data.filter((kit) => kit !== null);
          localStorage.setItem("allSaveKits", JSON.stringify(response.data));
          showHtmlKits(response.data);
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
} else {
  const apiUrl = "https://website-0bc9a756.frt.izk.mybluehost.me/api/getAction";
  if (__st.cid) {
    let allSaveKits = localStorage.getItem("allSaveKits");
    // console.log(allSaveKits);
    if (allSaveKits) {
      allSaveKits = JSON.parse(allSaveKits);
      showHtmlKits(allSaveKits);
    } else {
      const url = new URL(apiUrl);
      url.searchParams.append("id", __st.cid);

      fetch(url, {
        method: "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json(); // Assuming the response is JSON
        })
        .then((response) => {
          console.log("Response custom:", response);
          if (response.status == "success") {
            response.data = response.data.filter((kit) => kit !== null);
            localStorage.setItem("allSaveKits", JSON.stringify(response.data));
            showHtmlKits(response.data);
          }
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    }
  }
}

function hideNotification() {
  setTimeout(function () {
    const notification = document.getElementById("cart-notification");
    notification.classList.remove("animate", "active");
  }, 2000);
}
/**/
let cartIconVal = document.querySelector(".cart-count-bubble span");
const cartIconbubble = document.querySelector("#cart-icon-bubble");
const hasCustomHeaderCartIcon = cartIconbubble && cartIconbubble.querySelector(".hidden__cart-icon");
if (!cartIconVal && cartIconbubble && !hasCustomHeaderCartIcon) {
  cartIconbubble.innerHTML += `<div class="cart-count-bubble"><span aria-hidden="true"></span><span class="visually-hidden">0 items</span>
        </div>`;
} else if (cartIconVal) {
  cartIconVal.innerHTML = '';
}

getCarts()
/**/
async function getCarts() {
  console.log("Cart call");
  var cartContents = await fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  const officialItemCount =
    typeof cartContents.item_count === "number" ? cartContents.item_count : 0;
  document.querySelectorAll("[data-cart-item-count]").forEach((el) => {
    const n = String(officialItemCount);
    if (
      el instanceof HTMLInputElement ||
      el instanceof HTMLTextAreaElement ||
      el instanceof HTMLSelectElement
    ) {
      el.value = n;
    } else {
      el.textContent = n;
    }
    el.setAttribute("data-cart-item-count", n);
  });
  
  var cartKits = [];
  for(let item of cartContents.items){
    const property = item.properties;
    if(property){
      const name = property.kitName;
      const kitQuantity = property.kitQuantity;
      if(name != undefined){
        const cartkk = cartKits.find(x => x. name == name)
        if(cartkk != undefined){
          cartkk.price +=item.price*item.quantity;
        }else{
          cartKits.push({name: name,quantity: kitQuantity, price: item.price*item.quantity})
        }
      }else{
        cartKits.push({name: item.title,quantity: item.quantity, price: item.price*item.quantity}) 
      }
    }else{
      cartKits.push({name: item.title,quantity: item.quantity, price: item.price*item.quantity})
    }
  }
  const totalQan = cartKits.reduce(
    (total, item) => total + item.quantity*1,
    0
  );
  
  const totalPrice = cartKits.reduce(
    (total, item) => total + item.quantity*item.price,
    0
  );
  
  const cartItemsCount = document.querySelector(".cart-items__count");
  if (cartItemsCount) {
    cartItemsCount.innerText = `${totalQan} items`;
  }

  /* Header / icon bubbles must use Shopify item_count (same as [data-cart-item-count]).
     totalQan uses kit kitQuantity and undercounts (e.g. always 1 per kit name). */
  const countStr =
    officialItemCount < 100 ? String(officialItemCount) : "";
  document
    .querySelectorAll(".cart-count-bubble span[aria-hidden='true']")
    .forEach((el) => {
      el.textContent = countStr;
    });

  //
  const totalsTotal = document.querySelector(".cart__blocks .totals__total span");
  if(totalsTotal){
    totalsTotal.innerText = `(${totalQan} items per kit)`;
  }
  const totalsTotalValue = document.querySelector(".cart__blocks .totals__total-value");
  if(totalsTotalValue){
    const totalPr = (totalPrice/100).toFixed(2);
    totalsTotalValue.innerText = `$${totalPr}`;
  }

  return cartContents;
}

const removeKitsBtn = document.querySelectorAll(".remove-cart-kit");

removeKitsBtn.forEach((removekit) => {
  removekit.addEventListener("click", (e) => {
    const name = e.target.getAttribute("data-id");
    var kit = cartKits.find((x) => x.name == name);
    console.log(kit);
    let updates = {};
    for (let item of kit.items) {
      // const removd =document.querySelector(`a.kit-product__remove-button[data-id="${item.id}"]`);
      // console.log(removd);
      // if(removd){
      let cartRemData = {
        [item.id]: 0,
      };
      updates = { ...updates, ...cartRemData };

      // }
    }
    const length = Object.entries(updates).length;
    if (length > 0) {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  });
});

const addQuantityKitsBtn = document.querySelectorAll(
  ".kit-product__quantity-button"
);
let previusQuantity = 0;
let upQuantity = 0;
let mainKitId;

addQuantityKitsBtn.forEach((addQuantitykit) => {
  addQuantitykit.addEventListener("click", async (e) => {
    let target = event.target.classList.contains("kit-product__quantity-button")
      ? event.target
      : event.target.closest(".kit-product__quantity-button");
    const inputValue = target.parentElement.querySelector(
      ".kit-product-quanity"
    );
    previusQuantity = inputValue.value;
    if (target.classList.contains("kit-product__quantity-button--decrease")) {
      if((inputValue.value - 1) <= 0){
        inputValue.value = 1;
      }else{
       inputValue.value = inputValue.value - 1; 
      }
    } else if (
      target.classList.contains("kit-product__quantity-button--increase")
    ) {
      inputValue.value = inputValue.value * 1 + 1;
    }
    const addkitQuantityElements = document.querySelectorAll(
      ".kit-product__quantity-trigger"
    );
    
    addkitQuantityElements.forEach((addkitQuantityElement) => {
      addkitQuantityElement.setAttribute("kit-quantity", inputValue.value);
    })
    upQuantity = inputValue.value;
    mainKitId = inputValue.getAttribute("data-id");
    const products = document.querySelectorAll(
      '.kit-products[data-kit="' + mainKitId + '"] .kit-product'
    );

    const allitmes = [];
    if (checkouButton) {
      checkouButton.setAttribute('disabled', "true");
      checkouButton.innerHTML = `Checkout <img src="https://cdn.shopify.com/s/files/1/0864/0784/0055/files/loader.gif?v=1724743455" height="20" style="margin-left: 10px;">`;
    }
    changeCartQuantity(products, 0);
  });
});

const addQuantitysBtn = document.querySelectorAll(
  "quantity-popover .cart-quantity .quantity__button"
);

addQuantitysBtn.forEach((addQuantity) => {
  addQuantity.addEventListener("click", async (e) => {
    let target = event.target.classList.contains("quantity__button")
      ? event.target
      : event.target.closest(".quantity__button");
    const inputValue = target.parentElement.querySelector(".quantity__input");
    const variantIdKey = inputValue.getAttribute("data-quantity-variant-id");
    const variantId = inputValue.getAttribute("data-variant-id");
    if (target.getAttribute("name") === "minus") {
      // inputValue.value = inputValue.value-1;
      const response = await updateQuantity(variantIdKey, inputValue.value);
      updatePrice(variantId, response);
      getCarts();
    } else if (target.getAttribute("name") === "plus") {
      // inputValue.value =inputValue.value*1+1;
      const response = await updateQuantity(variantIdKey, inputValue.value);
      updatePrice(variantId, response);
      getCarts();
    }
  });
});

const addQuantityKitItemsBtn = document.querySelectorAll(
  ".kit-item-product__quantity-button"
);
addQuantityKitItemsBtn.forEach((addQuantityKitItem) => {
  addQuantityKitItem.addEventListener("click", async (e) => {
    let target = event.target.classList.contains("kit-item-product__quantity-button")
      ? event.target
      : event.target.closest(".kit-item-product__quantity-button");
    const inputValue = target.parentElement.querySelector(
      ".kit-item-product-quanity"
    );
    let previusItemQuantity = inputValue.value;
    if (target.classList.contains("minus")) {
      if((inputValue.value - 1) <= 0){
        inputValue.value = 1;
      }else{
       inputValue.value = inputValue.value - 1; 
      }
    } else if (
      target.classList.contains("plus")
    ) {
      inputValue.value = inputValue.value * 1 + 1;
    }
    let proprty = {};
    const variantId = inputValue.getAttribute("data-quantity-variant-id");
    const cartItem = target.parentElement;
    const cartKitQuantity = cartItem.getAttribute("kit-quantity");
    // let quantityItem = cartKitQuantity/previusItemQuantity;
    //console.log(quantityItem);
    /* quantityItem = cartKitQuantity*inputValue.value;*/
    quantityItem = inputValue.value;
    quantityItem = parseInt(quantityItem);
    //
    const mainKitItemId = inputValue.getAttribute("data-id");
    let key = "kitName";
    proprty[key] = mainKitItemId;
    proprty["kitQuantity"] = cartKitQuantity;
    if (checkouButton) {
      checkouButton.setAttribute('disabled', "true");
      checkouButton.innerHTML = `Checkout <img src="https://cdn.shopify.com/s/files/1/0864/0784/0055/files/loader.gif?v=1724743455" height="20" style="margin-left: 10px;">`;
    }
    const response = await updateQuantity(variantId, quantityItem, proprty);
    if (checkouButton) {
      checkouButton.removeAttribute('disabled');
      checkouButton.innerHTML = `Checkout`;
    }
    updateKitItemPrice(mainKitItemId);
    updateItemsKey();
  })
})

async function changeCartQuantity(products, ind) {
  if (products.length > ind) {
    let proprty = {};
    const product = products[ind];
    const quantityInput = product.querySelector(".kit-item-product-quanity");
    if (quantityInput) {
      const variantId = quantityInput.getAttribute("data-quantity-variant-id");
      const quantity = quantityInput.value;
     // const actualQuantity = quantity / previusQuantity;
      let finalQuantity = quantity;
      finalQuantity = parseInt(finalQuantity);
      var key = "kitName";
      proprty[key] = mainKitId;
      proprty["kitQuantity"] = upQuantity;
      const response = await updateKitQuantity(
        variantId,
        finalQuantity,
        proprty,
        products,
        ind
      );
    }
  } else {
     if (checkouButton) {
       checkouButton.removeAttribute('disabled');
       checkouButton.innerHTML = `Checkout`;
     }
    updateKitItemPrice(mainKitId);
    updateItemsKey();
  }
}


async function updatePrice(variantId, response) {
  const itemPrice = document.querySelector(
    '.cart-item__price-wrapper[data-price-id="' + variantId + '"]'
  );
  const items = response.items;
  const item = items.find((x) => x.variant_id == variantId);
  if (item != undefined) {
    itemPrice.innerHTML = `<span class="price price--end">
                                  $${(item.final_line_price / 100).toFixed(2)}
                                </span>`;
  } else {
    let parentElement = itemPrice;
    while (parentElement && !parentElement.classList.contains("cart-item")) {
      parentElement = parentElement.parentElement;
    }
    if(parentElement){
      parentElement.remove();
    }
  }
}

async function updateKitItemPrice(mainKitItemId) {
  const kitItem = document.querySelector('.kit-item[data-kit="'+mainKitItemId+'"]');
  const cartKitQuantity = kitItem.querySelector('.kit-product-quanity').value;
 
  const products = document.querySelectorAll(
    '.kit-products[data-kit="' + mainKitItemId + '"] .kit-product'
  );
  let totalQuantity = 0;
  let totalPrice = 0;
  products.forEach(async (product) => {
    let qty = 1;
    const quantityInput = product.querySelector('.kit-item-product-quanity');
    if (quantityInput) {
     // qty = quantityInput.value * cartKitQuantity;
      qty = quantityInput.value*1;
    }
   /* const quantityCaseSpan = product.querySelector('.kit-product__variant span');
    quantityCaseSpan.innerText = qty;*/
    totalQuantity += qty;
    const priceItemP = product.querySelector('.kit-product__price');
    const price = priceItemP.getAttribute('data-price');
    totalPrice += price * qty;
  });
  /*const getKitNameElements = document.querySelectorAll('.kit-name');
  getKitNameElements.forEach(async (element) => {
    console.log(element.innerText);
    if (element.innerText == mainKitItemId) {
      const kitItemCount = element.parentElement.querySelector('.kit-items-count');
      console.log(kitItemCount)
      kitItemCount.innerText = totalQuantity;
    }
  })*/
  const kitItemCount = kitItem.querySelector('.kit-items-count');
  kitItemCount.innerText = totalQuantity;
  
/*  const cartItemKitQuantity = kitItem.querySelector('.kit-items-counts');
  cartItemKitQuantity.innerText = cartKitQuantity;
  */
  const kitItemPrice = kitItem.querySelector('.kit-item__price span');
  /***/
  totalPrice = totalPrice * cartKitQuantity;
  kitItemPrice.innerText = '$'+totalPrice.toFixed(2);
}

async function updateItemsKey(){
  const cart = await getCarts();
  
  const quantityElements = document.querySelectorAll(
      ".kit-item-product-quanity"
  );
  quantityElements.forEach((quantityElement) => {
    const var_id = quantityElement.getAttribute('data-variant-id');
    const kitName = quantityElement.getAttribute('data-id');
    const line_item = cart.items.find(x => x.variant_id == var_id && x.properties.kitName == kitName);
    if(line_item != undefined){
       quantityElement.setAttribute('data-quantity-variant-id', line_item.key) 
    }
  })
}

async function updateKitQuantity(id, quantity, proprty = null, products, ind) {
  // Check if id and quantity are valid
  if (!id || quantity == null || quantity < 0) {
    console.error("Invalid id or quantity");
    return;
  }

  // Construct the URL
  const url = window.Shopify.routes.root + "cart/change.js";

  // Define the payload
  let payload = {
    id: id,
    quantity: quantity,
  };
  if (proprty) {
    payload = {
      id: id,
      quantity: quantity,
      properties: proprty,
    };
  }

  // Make the fetch request
  const data = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorInfo) => Promise.reject(errorInfo));
      }
      return response.json();
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error:", error);
      return error;
    });
  ind++;
  changeCartQuantity(products, ind);
}

async function updateQuantity(id, quantity, proprty = null) {
  // Check if id and quantity are valid
  if (!id || quantity == null || quantity < 0) {
    console.error("Invalid id or quantity");
    return;
  }

  // Construct the URL
  const url = window.Shopify.routes.root + "cart/change.js";

  // Define the payload
  let payload = {
    id: id,
    quantity: quantity,
  };
  if (proprty) {
    payload = {
      id: id,
      quantity: quantity,
      properties: proprty,
    };
  }

  // Make the fetch request
  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorInfo) => Promise.reject(errorInfo));
      }
      return response.json();
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error:", error);
      return error;
    });
}

checkouButton && checkouButton.setAttribute('type', "button");
checkouButton && checkouButton.addEventListener("click", function() {
    createDrafrOrder(checkouButton);
  });
// createDrafrOrder();
// async function createDrafrOrder(button){
//  /* if (__st.cid) {*/
//     button.setAttribute('disabled', "true");
//     const cart = await getCarts();
//     const response = await fetch('https://enday-kits.vercel.app/api/createdraft', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ shop: Shopify.shop, items: cart.items }),
//         });
//     const data = await response.json();
//     button.removeAttribute("disabled");
//     console.log(cart.items);
//     if(data.url != undefined){
//       // window.location.href = data.url;
//     }
//  /* }*/
// }


async function createDrafrOrder(button){
 /* if (__st.cid) {*/
    button.setAttribute('disabled', "true");
    const cart = await getCarts();

    // Only keep items that have a "kitName" property (any value)
    const kitItems = cart.items.filter(item =>
      item.properties && Object.prototype.hasOwnProperty.call(item.properties, 'kitName')
    );

    const response = await fetch('https://enday-kits.vercel.app/api/createdraft', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ shop: Shopify.shop, items: kitItems }),
        });
    const data = await response.json();
    button.removeAttribute("disabled");
    // console.log(kitItems);
    if(data.url != undefined){
      window.location.href = data.url;
    }
 /* }*/
}

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('more_detail')) {
        var closestGridItemmodal = event.target.closest('.grid__item');
        if (closestGridItemmodal) {
            closestGridItemmodal.querySelector('modal-opener button').click();
        }
    }
});
